const supportedCreateReminderActions = {
  'create-reminder': 1,
};

export type CreateReminderAction = keyof typeof supportedCreateReminderActions;

export const isCreateReminderAction = (value?: unknown): value is CreateReminderAction =>
  typeof value === 'string' ? value in supportedCreateReminderActions : false;
